import React, { useState, useEffect } from 'react';
import { Box, Button, Avatar, Typography, IconButton, Tabs, Tab, TextField, Grid, Paper, Card, Chip, Modal, Stack, useTheme, useMediaQuery } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { Add, ArrowBack, Close, List } from '@mui/icons-material';
import { CustomerService } from '../Service';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import AccountStatusIndicator from './AccountStatusIndicator';
import VerifyOtp from './VerifyOtp';
import { isMobile } from 'react-device-detect';
import Loading from '../../../components/Loader/Loading';
import BookingHistory from './BookingHistory';
import { PermissionGuard } from '../../../components/PermissionGuard';
import BasicDetails from './PersonalDetail';
import PersonalDetails from '../PersonalDetail';
import ChangeMobileNumber from './ChangeMobileNumber';
import WalletDetails from './WalletDetails';
import IsTesterIndicator from './IsTesterIndicator';


const CustomerProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [personalDetails, setPersonalDetails] = useState({});
  const [bookingList, setBookingList] = useState([]);

  /************ customer mobile/otp verification related ***********/
  const [customerVerificationModal, setCustomerVerificationModal] = useState(null);
  const sendOtp = async (customerData) => {
    //  setAnchorEl(null);
    // console.log("selected customer :",customerData)
    const result = await Swal.fire({
      text: "Do you want to Verify Customer now?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Verify now!',
      cancelButtonText: 'No, Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
    });

    if (result.isConfirmed) {
      try {
        // Show loading state
        const loadingDialog = Swal.fire({
          title: 'Processing...',
          text: 'Please wait while sending the otp',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Make the API call
        const response = await CustomerService.verifyCustomerByMobileNo({ mobileNumber: customerData.mobileNumber });
        // console.log("mobile number submission response:", response);

        // Always close the loading dialog
        await Swal.close();

        if (response.success == '1') {
          setCustomerVerificationModal('verify Otp');
          return true;
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: response.message || 'Failed to send otp'
          });
          return false;
        }

      } catch (error) {
        // Always close the loading dialog in case of error
        await Swal.close();
        await Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while Verifying customer'
        });
        return false;
      }
    } else {
      return false;
    }
  }
  const handleModalClose = () => {
    fetchData();
    setNumberToUpdate(null);
    setCustomerVerificationModal(null);
  }


  const fetchData = async () => {
    setIsLoading(true);
    const response = await CustomerService.fetchCustomerDetailById(id);
    console.log('response:', response)
    if (response.success== '1') {
      const { cBooking, ...restAll } = response.data
      setPersonalDetails(restAll);
      setBookingList(cBooking);
      setIsLoading(false);
    }else {
      setIsLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to fetch customer details'
      });
    }
  }

  useEffect(() => {

    if (id && id > 0) {
      fetchData();
    }
  }, [id]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderForm = () => {
    switch (activeTab) {
      case 0:
        return (
          <BasicDetails personalDetails={personalDetails} fetchData={fetchData} customerVerificationModal={customerVerificationModal} setCustomerVerificationModal={setCustomerVerificationModal} />

        );
      case 1:
        return (
          <BookingHistory bookingList={bookingList} />
        );
      case 2:
        return (
          <WalletDetails walletData={{ totalCoins: personalDetails?.totalCoin || 0 }} fetchData={fetchData} />
        );
      default:
        return null;
    }
  };

  const [numberToUpdate, setNumberToUpdate] = useState(null);


  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <>
      {/* <Card sx */}
      {isLoading && <Loading />}
      <PageHeaderLayout headerTitle={'Customer Profile'}>
        <PermissionGuard feature='service-expert' permission='canEdit'>
          <Button sx={{textTransform:'capitalize'}} startIcon={<BorderColorOutlinedIcon />} color='warning' variant='contained' size='small' onClick={() => navigate(`/admin/customer/${id}`)}>
            Edit
          </Button>
        </PermissionGuard>
        {/* <PermissionGuard feature='service-expert' permission='canCreate'>
          <Button startIcon={<Add />} sx={{display:{xs:'none',sm:'flex'}, bgcolor: '#3a2bde',textTransform:'capitalize' }} variant='contained' size='small' onClick={() => navigate(`/admin/customer/0`)}>
            Add New
          </Button>
        </PermissionGuard>
        <PermissionGuard feature='customer' permission='canView'>
          <Button size='small' variant='contained' onClick={() => navigate('/admin/customers')} startIcon={<List sx={{fontSize: '.85rem!important' }} />} sx={{ display:{xs:'none',md:'flex'}, height: "30px", marginTop: "10px" ,textTransform:'capitalize'}}>
            Show Customer List
          </Button>
        </PermissionGuard> */}
      </PageHeaderLayout>
      <Grid container spacing={1} sx={{}}>
        <Grid item xs={12} md={3}>
          <Paper>
            <Grid container>
              <Grid item xs={6} md={12} >
                <Box sx={{ p: 2, textAlign: 'center', borderBottom: '1px dashed lightGray' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Avatar
                      src={''}
                      // alt="Profile"
                      sx={{ width: {xs:'5rem',sm:'7rem',md:'10rem'}, height: {xs:'5rem',sm:'7rem',md:'10rem'}, border: '4px solid white' }}
                    />
                  </Box>
                  <Typography variant="body1" sx={{ fontSize: '0.85rem' }}>{`${personalDetails?.profile?.firstName || ''} ${personalDetails?.profile?.middleName || ''} ${personalDetails?.profile?.lastName || ''}`}</Typography>
                  {!isLoading &&
                    <AccountStatusIndicator customerData={personalDetails} fetchUserDetails={fetchData} setOpenOtpModal={setCustomerVerificationModal} />
                  }
                  
                  <IsTesterIndicator isTester={personalDetails?.isTester} fetchData={fetchData} />
                </Box>
              </Grid>
              <Grid item xs={6} md={12} sx={{borderLeft:{xs:'1px dashed lightGray',lg:'none'},display:'flex',flexDirection:'column',justifyContent:'center'}}>
                <Tabs
                  orientation={"vertical"}
                  variant="scrollable"
                  value={activeTab}
                  onChange={handleTabChange}
                  // sx={{ borderRight: 1, borderColor: 'divider', width: '100%' }}
                  sx={{
                    borderRight: 1, borderColor: 'divider', width: '100%',
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#3a2bde', // Custom indicator color
                    },
                    // '& .MuiTab-root': {
                    //     color: '#3a2bde', // Custom text color
                    // },
                    //active tab text color
                    '& .Mui-selected': {
                      color: '#3a2bde!important',
                    },

                  }}
                >
                  <Tab label="Personal Details" sx={{ borderBottom: '1px solid lightGray', fontSize: '.8rem',maxWidth:'none' }} />
                  <Tab label="Booking History" sx={{ borderBottom: '1px solid lightGray', fontSize: '.8rem',maxWidth:'none' }} />
                  <Tab label="Wallet Details" sx={{ borderBottom: '1px solid lightGray', fontSize: '.8rem',maxWidth:'none' }} />
                </Tabs>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} md={9}>
          <Box sx={{ flexGrow: 1, }}>
            <Box elevation={3} >
              {renderForm()}
            </Box>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              {/* <PermissionGuard feature='service-expert' permission='canEdit'>
                <Button startIcon={<BorderColorOutlinedIcon/>} color='warning' variant='contained' size='small' onClick={()=>navigate(`/admin/customer/${id}`)}>
                  Edit
                </Button>
              </PermissionGuard> */}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* ================ Verify Customer Modal=============== */}
      <Modal
        open={customerVerificationModal}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box sx={{
          position: 'absolute',
          top: (isMobile) ? '80%' : '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          // border: '2px solid #ddd',
          boxShadow: 24,
          p: 2,
        }}
          width={(isMobile) ? "95%" : "50%"}
        >
          <Box sx={{ textAlign: 'end' }}>
            <Button size='small' variant='outlined' color='error' startIcon={<Close />} onClick={handleModalClose}>close</Button>
          </Box>
          {customerVerificationModal == 'verify otp' && <VerifyOtp customerMobileNumber={personalDetails?.mobileNumber}
            mobileNumber={numberToUpdate ? numberToUpdate : personalDetails.mobileNumber}
            sendOtp={sendOtp}
            setOpenOtpModal={setCustomerVerificationModal}
            onClose={handleModalClose}
          />}
          {customerVerificationModal == 'change mobile number' &&
            <ChangeMobileNumber
              openModel={customerVerificationModal == 'change mobile number' ? true : false}
              currentMobileNumber={personalDetails?.mobileNumber}
              onCloseModel={() => {
                setCustomerVerificationModal(null);
              }}
              verifyNewNumber={(newNumber) => {
                // fetchData();
                console.log('new number:', newNumber)
                setNumberToUpdate(newNumber);
                setCustomerVerificationModal('verify otp and update number');
              }}
            />
          }
          {customerVerificationModal == 'verify otp and update number' &&
            <VerifyOtp
              mobileNumber={personalDetails?.mobileNumber}
              newMobileNumber={numberToUpdate}
              sendOtp={sendOtp}
              setOpenOtpModal={setCustomerVerificationModal}
              onClose={handleModalClose}
            />
          }
        </Box>
      </Modal>

    </>
  );
};

export default CustomerProfile;